import { useState } from "react";
import { loginService } from "../services/loginService";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function useLoginService() {
  const { login, setCommonSuccess, setCommonWarning, setCommonError } =
    useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const performLogin = async (username, password) => {
    setLoading(true);
    setError("");

    try {
      const data = await loginService(username, password);
      console.log("Login API response:", data);

      // Assuming API returns: { token, user, message }
      if (data?.status === 200) {
        login(data.data, data.token);
        setCommonSuccess("Login successful!");
        // window.location.href = "/"; // Full page reload to reset state
      } else if (data.status === 401) {
        navigate("/login");
        return []; // return empty if unauthorized
      } else {
        setCommonWarning(data?.message || "Invalid login credentials");
      }

      return data;
    } catch (err) {
      const message =
        err.response?.data?.message || "Login failed. Please try again.";
      setCommonError(message);
      setError(message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { performLogin, loading, error };
}
